import React, {Component} from 'react';
import propTypes from 'prop-types';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';

//import components
import ItemYearbookListItemNumber from './ItemYearbookListItemNumber.js';

class ItemYearbookListItem extends Component {
    componentDidMount() {
        const {journalNumbers, cardId, id, setYear, reasonOfResignationPublic} = this.props;
        const isCurrentThere = journalNumbers.filter(number => parseInt(number.id, 10) === parseInt(cardId, 10)).length > 0;

        if (isCurrentThere) {
            setYear({id: id, reasonOfResignationPublic: reasonOfResignationPublic});
        }
    };

    toggleOpened = () => {
        const {id, reasonOfResignationPublic, setYear, currentYear, resetYear} = this.props;
        const isOpened = currentYear && currentYear.id === id;

        if (!isOpened) {
            setYear({id: id, reasonOfResignationPublic: reasonOfResignationPublic});
        } else {
            resetYear();
        }
    };

    render() {
        const {journalNumbers, link, description, id, currentYear, label, recordsNumber, cardId} = this.props;
        const isOpened = currentYear && currentYear.id === id;

        return (
            <li className={`card__yearbook__list-item ${journalNumbers.length > 0 ? '' : 'without-button'}`}>
                <div className="card__yearbook__list-item-container">
                    {journalNumbers.length > 0 &&
                        <button className={isOpened ? "card__yearbook__year-hide" : "card__yearbook__year-open"}
                            onClick={() => this.toggleOpened()}>
                            {!isOpened && <span>+</span>}
                            {isOpened && <span>-</span>}
                        </button>}
                    <div className="card__yearbook__year-label">
                        <Link className="card__yearbook__year" to={link} dangerouslySetInnerHTML={{__html: label}}></Link>
                        {description &&
                            <span className="card__yearbook__year--first" dangerouslySetInnerHTML={{__html: description}}>
                            </span>}
                        <span className="card__yearbook__year-number">{recordsNumber}</span>
                    </div>
                </div>
                {isOpened && journalNumbers.length > 0 &&
                    <ul className="card__yearbook__number-list">
                        {journalNumbers.map((journalNumber, index) => <ItemYearbookListItemNumber {...journalNumber} key={index} cardId={cardId}/>)}
                    </ul>}
            </li>
        );
    };
};

ItemYearbookListItem.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(ItemYearbookListItem);



// WEBPACK FOOTER //
// ./src/components/items/cards/ItemYearbookListItem.js